@if (handleCustomerHeader()) {
  <app-customer-header></app-customer-header>
}

@if (handleMenuNavHeader()) {
  <app-menu-nav></app-menu-nav>
}
